import { registerSW as defaultRegisterSW } from 'virtual:pwa-register'

type PwaRegistrar = typeof defaultRegisterSW

export function attachPwaUpdateChecks(registration: { update: () => Promise<unknown> }) {
  const check = () => {
    void registration.update()
  }
  const onVisibility = () => {
    if (document.visibilityState === 'visible') check()
  }
  document.addEventListener('visibilitychange', onVisibility)
  return () => document.removeEventListener('visibilitychange', onVisibility)
}

export function registerPwa(register: PwaRegistrar = defaultRegisterSW) {
  return register({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (registration) attachPwaUpdateChecks(registration)
    },
  })
}
